import React from "react";

// NP Associates monogram - Swiss/high-contrast wordmark
export const Logo = ({ className = "", variant = "dark" }) => {
  const color = variant === "dark" ? "text-foreground" : "text-white";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="np-associates-logo">
      <div
        className="relative flex h-10 w-10 items-center justify-center bg-primary text-primary-foreground"
        aria-hidden="true"
      >
        <span className="font-[Outfit] text-lg font-black tracking-tighter">NP</span>
        <span className="absolute -bottom-1 -right-1 h-2 w-2 bg-foreground" />
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-[Outfit] text-[15px] font-extrabold uppercase tracking-[0.15em] ${color}`}>
          NP Associates
        </span>
        <span className="mt-1 font-[Outfit] text-[9px] font-medium uppercase tracking-[0.22em] text-muted-foreground">
          GST & Income Tax Auditors
        </span>
      </div>
    </div>
  );
};

export default Logo;
